// Central configuration for report date-window defaults.
//
// The StartEndDate filter normally defaults to "Since Start" (a very large day
// count). Some reports should instead default to a short, recent window. Keep
// that list here so it only has to be maintained in one place.

// Day count representing the "Since Start" preset.
export const SINCE_START_DAYS = 7000;

// Reports whose StartEndDate filter should default to a 7-day window
// instead of "Since Start". Add report IDs here as needed.
export const SEVEN_DAY_DEFAULT_REPORT_IDS = [63];

/**
 * Returns the default number of days for a report's StartEndDate window.
 * Reports listed in SEVEN_DAY_DEFAULT_REPORT_IDS default to 7 days; all
 * others default to "Since Start".
 */
export const getStartEndDateDefaultDays = (reportId: number): number => SEVEN_DAY_DEFAULT_REPORT_IDS.includes(reportId) ? 7 : SINCE_START_DAYS;
